import styled from 'styled-components'
import darkBg from 'resources/svg/ppl-quote-dark.svg'
import lightBg from 'resources/svg/ppl-quote-light.svg'
import quoteSvg from 'resources/svg/icons/quote.svg'

export const Wrapper = styled.div`
  padding: 0 15px;
  max-width: 950px;
  margin: 8vw auto 5vw;

  > p {
    text-align: center;
    margin: 5px 0;
    padding: 0 30px;
  }

  > h2 {
    margin-bottom: 10px;
  }

  .container {
    margin: 50px auto 5vw;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 20px;
  }

  .box {
    text-align: center;
    padding: 30px;
    margin: auto;
    background: url(${lightBg}) no-repeat center / contain;
    color: ${props => props.theme.palette.general.light};
    min-height: 250px;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:nth-of-type(2) {
      background: url(${darkBg}) no-repeat center / contain;
    }

    p {
      font-family: ${props => props.theme.font.alt.family};
      font-size: 16px;
      margin: 18px 0;
      line-height: 1.5;
    }

    em {
      display: block;
      font-size: 12px;
    }

    .icon-quote {
      &::before {
        content: '';
        display: block;
        width: 30px;
        height: 30px;
        background: url(${quoteSvg}) no-repeat center / contain;
        filter: brightness(100);
      }
    }
  }
`
